import { CommonModule } from '@angular/common';
import { Component, inject, input, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { Highlight } from 'ngx-highlightjs';
import { AppShieldEventLogsStore, ShieldLogsItemModel, WafRuleSeverityEnum } from '@bn/app-shield';
import { Size, StringBooleanMap } from '@bn/shared/entities/models';
import { JsonFormatPipe } from '@bn/shared/entities/pipes';
import { DateTimeFormat, DateTimeUtils } from '@bn/shared/utils';
// Note: pipe has to be imported like this instead of:
// import { WafSeverityRulePipe } from '@bn/app-shield';
// this caused an error on runtime and it was hard to find
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { DatePickerComponent } from '@bn/web-ui/datepicker/datepicker.component';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { FlagComponent } from '@bn/web-ui/flag/flag.component';
import { NotAvailableTemplateComponent } from '@bn/web-ui/not-available';
import { PrevNextPaginationComponent } from '@bn/web-ui/prev-next-pagination/prev-next-pagination.component';
import { TableSkeletonTemplateComponent } from '@bn/web-ui/standalone';
import { GetLogDropdownItemsPipe } from './pipes';

@Component({
  selector: 'app-app-shield-event-logs-waf',
  templateUrl: './app-shield-event-logs.component.html',
  styleUrls: ['./app-shield-event-logs.component.scss'],
  imports: [
    BadgeComponent,
    CommonModule,
    GetLogDropdownItemsPipe,
    Highlight,
    JsonFormatPipe,
    TranslateModule,
    FormsModule,
    ButtonComponent,
    DatePickerComponent,
    DropdownMenuComponent,
    FlagComponent,
    PrevNextPaginationComponent,
    FaIconComponent,
    TableSkeletonTemplateComponent,
    NotAvailableTemplateComponent,
  ],
  providers: [AppShieldEventLogsStore, JsonFormatPipe, TranslatePipe],
})
export class AppShieldEventLogsWafComponent {
  readonly showFilter = input(true);
  readonly showPagination = input(true);
  readonly isLoading = input(false);
  readonly logs = input<ShieldLogsItemModel[] | null>(null);

  @Input()
  public showHeader? = true;

  @Input()
  public hideLastBorder? = true;

  @Input()
  public lastRowBorderRadius? = false;

  @Input()
  public headerSize?: Extract<Size, 'sm' | 'md'> = 'sm';

  @Input()
  public notAvailableOptions?: {
    show?: boolean;
    noShadow?: boolean;
    noImage?: boolean;
    noTitle?: boolean;
    noPaddingTop?: boolean;
  };

  readonly eventStore = inject(AppShieldEventLogsStore);
  readonly datePickerConfig = input<Partial<BsDaterangepickerConfig>>({});
  datePickerValue = DateTimeUtils.dayjsNow().toDate();
  public showDropdown = false;
  public wafRuleSeverityEnum = WafRuleSeverityEnum;
  public openRows: StringBooleanMap = {};

  public readonly dateFormat = DateTimeFormat.DateTimeLong;

  public onRowToggle(index: number): void {
    this.openRows[index] = !this.openRows[index] || false;
  }

  // Note: we share template with another component this is why we need to keep this function here.
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onDropdownClick(_item: DropdownMenuItem): void {}

  public onPaginationChange(_token: string | null): void {
    throw Error('Not implemented');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onDatePickerChange(_event: any): void {
    throw Error('Not implemented');
  }

  // Note: we share template with another component this is why we need to keep this function here.
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onButtonRefresh(): void {}
}
